import React from "react";
import { Dialog, DialogContent, DialogActions } from "@mui/material";
import { styled } from "@mui/material/styles";
import Button from "../../../../component-lib/Molecules/button/Button";
import CloseIcon from "@mui/icons-material/Close";
import { TEXT_CONSTANTS } from "../../../../utils/text-constants/textConstants";
import Heading from "../../../../component-lib/Atoms/heading/EventEHRHeading";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": { padding: "16px 24px" },
  "& .MuiDialogActions-root": { padding: theme.spacing(1) },
  "& .MuiPaper-root": {
    borderRadius: "8px",
    height: "auto",
    width: "850px",
    maxWidth: "none",
  },
}));

interface UserViewDialogProps {
  isOpen: boolean;
  dialogHeading?: string;
  handleClose: () => void;
  departmentName?: any;
  defaultDataForUser: any;
  selectedTabForUser?: string;
}

const UserViewDialog = ({
  isOpen,
  departmentName,
  defaultDataForUser,
  handleClose,
  dialogHeading,
  selectedTabForUser,
}: UserViewDialogProps) => {
  const isProvider = !!defaultDataForUser?.providerName;

  const nameDepartment = defaultDataForUser?.departments.map(
    (data: any) => data?.department?.name
  );
  const formate = nameDepartment.join(", ");
  const headerStyle = {
    fontWeight: "600",
    fontSize: "18px",
    paddingBottom: "10px",
  };

  return (
    <React.Fragment>
      <BootstrapDialog
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            handleClose();
          }
        }}
        aria-labelledby="customized-dialog-title"
        open={isOpen}
      >
        <div
          className="flex justify-between items-center rounded-lg"
          style={{ margin: "14px 24px" }}
        >
          <Heading title={dialogHeading ?? ""} customStyle={headerStyle} />

          <div onClick={handleClose} className="cursor-pointer">
            <CloseIcon />
          </div>
        </div>

        <DialogContent dividers>
          {defaultDataForUser?.id ? (
            <div
              style={{
                padding: "24px 16PX",
                display: "grid",
                gap: "24px 16px",
                gridTemplateColumns: "1fr 1fr",
                border: "1px solid #E8E8E8",
              }}
            >
              {isProvider ? (
                <>
                  <p>
                    <strong>BSA ID: </strong>
                    {defaultDataForUser?.bsaId}
                  </p>
                  <p>
                    <strong>{selectedTabForUser} Name: </strong>
                    {defaultDataForUser?.providerName}
                  </p>
                </>
              ) : (
                <>
                  <p>
                    <strong>BSA ID: </strong>
                    {defaultDataForUser?.staffId}
                  </p>
                  <p>
                    <strong>{selectedTabForUser} Name: </strong>
                    {defaultDataForUser?.staffName}
                  </p>
                </>
              )}

              <p>
                <strong>Email: </strong> {defaultDataForUser?.email || "-"}
              </p>
              <p>
                <strong>Contact Number: </strong>{" "}
                {defaultDataForUser?.contactNumber || "-"}
              </p>
              <p>
                <strong>Role:</strong> {defaultDataForUser?.role || "-"}
              </p>
              <p>
                <strong>Gender:</strong> {defaultDataForUser?.gender || "-"}
              </p>
              <p>
                <strong>Work Location:</strong> {departmentName || "-"}
              </p>
              <p>
                <strong>Status:</strong> {defaultDataForUser?.status || "-"}
              </p>
              <p>
                <strong>Departments:</strong> {formate || "-"}
              </p>
            </div>
          ) : (
            <p>No data available</p>
          )}
        </DialogContent>

        <DialogActions>
          <div className="p-2">
            <Button
              label={TEXT_CONSTANTS?.CLOSE}
              variant="contained"
              onClickCb={handleClose}
              style={{
                width: "120px",
                height: "44px",
                padding: "12px 20px",
                fontSize: "16px",
                marginRight: "6px",
              }}
            />
          </div>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
};

export default UserViewDialog;
